export interface AssetConditionModel extends Partial<AssetConditionConfigModel> {
  colour: string;
  status: string;
  windowAvg: number;
}

export interface AssetConditionConfigModel {
  scaleLowerLimit: number;
  scaleUpperLimit: number;
  thresholdLowerLimit: number;
  thresholdUpperLimit: number;
}

export interface AssetConditionPayloadModel {
  from: string;
  to: string;
  entityId: string;
  attributeName: string;
}

export interface MasterAttributeDataModel {
  name: string;
  value: number | string;
  thresholdLow: number;
  thresholdHigh: number;
}
